import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { RentalsService } from '../../../../../../services/rentals.service';
import { HelpersService } from '../../../../../../services/helpers.service';
import { AppConfig } from '../../../../../../app.config';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-rental-affiliate-config',
  templateUrl: './rental-affiliate-config.component.html',
  styleUrls: ['./rental-affiliate-config.component.scss'],
})
export class RentalAffiliateConfigComponent implements OnInit {
  @Input() affiliate;
  @Input() hasStripeConfigured;
  @Output() close = new EventEmitter();

  public editing: boolean = false;
  public loading: boolean = false;
  public saving: boolean = false;
  public deleting: boolean = false;

  public iFrameCreated: boolean = false;
  public dangerousURL: string;
  public iFrameLink: SafeResourceUrl | string;
  public iFrameSizer: SafeResourceUrl | string;
  public partnerIdentifier: string = '';

  constructor(
    private appConfig: AppConfig,
    private rentalsService: RentalsService,
    private helpersService: HelpersService,
    private messageService: MessageService,
    private translate: TranslateService,
    private sanitizer: DomSanitizer,
  ) {}

  ngOnInit() {
    document.documentElement.style.setProperty('--show-intercom', 'none');
    if (this.affiliate.id) {
      this.editing = true;
      this.getAffiliate();
    }
  }

  ngOnDestroy() {
    document.documentElement.style.setProperty('--show-intercom', 'inherit');
  }

  getRentalConfig() {
    this.rentalsService
      .getRentalConfiguration(this.helpersService.getPartnerId())
      .subscribe((config) => {
        this.partnerIdentifier = config.partnerIdentifier;
        this.createLink();
      });
  }

  getAffiliate() {
    this.loading = true;
    this.rentalsService
      .getRentalAffiliate(this.helpersService.getPartnerId(), this.affiliate.id)
      .subscribe(
        (affiliate: any) => {
          this.affiliate = affiliate;
          this.loading = false;
          this.getRentalConfig();
        },
        (err) => {
          this.loading = false;
        },
      );
  }

  isValid() {
    var isValid = false;

    if (
      this.affiliate.affiliateName &&
      this.affiliate.contactPerson &&
      this.affiliate.contactEmail &&
      this.affiliate.contactNumber &&
      (!this.affiliate.payCommission ||
        (this.affiliate.payCommission &&
          this.affiliate.commissionPercentage &&
          this.affiliate.payoutCycle)) &&
      (!this.affiliate.sendNotificationOnRental ||
        (this.affiliate.sendNotificationOnRental &&
          this.affiliate.rentalNotificationsAddresses))
    ) {
      isValid = true;
    }
    return isValid;
  }

  saveAffiliate() {
    if (this.affiliate.id) {
      this.updateAffiliate();
    } else {
      this.createAffiliate();
    }
  }

  createLink() {
    this.iFrameCreated = false;
    this.dangerousURL =
      this.appConfig.getRentalWidgetURL() +
      '/rentals/reserve/' +
      this.partnerIdentifier +
      '/affiliate/' +
      this.affiliate.webIdentifier +
      (this.appConfig.isDev() ? '?dev=true' : '');
    this.iFrameSizer = this.sanitizer.bypassSecurityTrustResourceUrl(
      this.appConfig.getRentalWidgetURL() + '/assets/js/iframeSizer.min.js',
    );
    this.iFrameLink = this.sanitizer.bypassSecurityTrustResourceUrl(
      this.dangerousURL,
    );
    this.iFrameCreated = true;
  }

  createAffiliate() {
    this.saving = true;

    const data = {
      ...this.affiliate,
      defaultPartnerID: this.helpersService.getPartnerId(),
    };
    this.rentalsService.createRentalAffiliate(data).subscribe(
      (affiliate: any) => {
        this.saving = false;
        this.close.emit();
      },
      (err) => {
        this.saving = false;
      },
    );
  }

  updateAffiliate() {
    this.saving = true;
    this.rentalsService.updateRentalAffiliate(this.affiliate).subscribe(
      (affiliate: any) => {
        this.saving = false;
        this.close.emit();
      },
      (err) => {},
    );
  }

  deleteAffiliate() {
    this.deleting = true;
    this.affiliate.isActive = false;
    this.rentalsService.updateRentalAffiliate(this.affiliate).subscribe(
      (affiliate: any) => {
        this.deleting = false;
        this.close.emit();
      },
      (err) => {
        this.deleting = false;
      },
    );
  }

  copyLink() {
    let anyNavigator: any;
    anyNavigator = window.navigator;
    anyNavigator.clipboard.writeText(this.dangerousURL).then(() => {
      this.messageService.add({
        life: 5000,
        closable: false,
        detail: this.translate.instant(
          'bikeshop.shop_ride_configuration.link_copied',
        ),
        key: 'link-copied',
      });
    });
  }

  copyiFrame() {
    var iframe = `<div style="width: 100%;">
    <style>
      iframe {
          width: 1px;
          min-width: 100%;
          border-width: 0px;
          height: 1500px;
      }
      </style>
        <script type="text/javascript" src="${this.appConfig.getRentalWidgetURL() + '/assets/js/iframeSizer.min.js'}"></script>
        <iframe id="rentals-iframe" src="${this.dangerousURL}"></iframe>
        <script>
            iFrameResize({ log: false}, '#rentals-iframe' );
        </script>
    </div>`;

    let anyNavigator: any;
    anyNavigator = window.navigator;
    anyNavigator.clipboard.writeText(iframe).then(() => {
      this.messageService.add({
        life: 5000,
        closable: false,
        detail: this.translate.instant(
          'bikeshop.shop_ride_configuration.iframe_copied',
        ),
        key: 'link-copied',
      });
    });
  }
}
